var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup d-flex justify-content-center align-items-center",
      class: { "popup--visible": _vm.is_open },
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row d-flex justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-12 col-md-10 col-lg-8 popup__container" },
            [
              _vm.is_open
                ? _c("div", {}, [
                    _c(
                      "a",
                      {
                        staticClass: "popup__close",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.closePopup.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "popup__close__ico",
                            attrs: {
                              width: "16px",
                              height: "16px",
                              viewBox: "0 0 16 16",
                              version: "1.1",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c(
                              "g",
                              {
                                attrs: {
                                  id: "desktop_design",
                                  stroke: "none",
                                  "stroke-width": "1",
                                  fill: "none",
                                  "fill-rule": "evenodd",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "cart",
                                      transform:
                                        "translate(-512.000000, -28.000000)",
                                      stroke: "#93999C",
                                      "stroke-width": "1.4",
                                    },
                                  },
                                  [
                                    _c(
                                      "g",
                                      {
                                        attrs: {
                                          id: "icon/closeGrey",
                                          transform:
                                            "translate(513.000000, 29.000000)",
                                        },
                                      },
                                      [
                                        _c("line", {
                                          attrs: {
                                            x1: "14",
                                            y1: "0",
                                            x2: "0",
                                            y2: "14",
                                            id: "Stroke-429",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("line", {
                                          attrs: {
                                            x1: "14",
                                            y1: "14",
                                            x2: "0",
                                            y2: "0",
                                            id: "Stroke-430",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c("div", { staticClass: "row pb-5" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c(
                              "h4",
                              {
                                staticClass:
                                  "heading__h4 font__family--gotham font__weight--medium font__color--gray pb-4 mb-0",
                              },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm.$t("address_data", "user_account")
                                    ) +
                                    "\n                                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("names-form", {
                              ref: "names_data_validate",
                              attrs: { name: _vm.forms_name },
                              model: {
                                value: _vm.names_data,
                                callback: function ($$v) {
                                  _vm.names_data = $$v
                                },
                                expression: "names_data",
                              },
                            }),
                            _vm._v(" "),
                            _c("shipment-data", {
                              ref: "billing_data_validate",
                              attrs: { name: _vm.edit_addresses },
                              model: {
                                value: _vm.shipping_data,
                                callback: function ($$v) {
                                  _vm.shipping_data = $$v
                                },
                                expression: "shipping_data",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 d-flex flex-wrap flex-sm-nowrap justify-content-center",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button button__size-2 button__font--size-1 button__bg--gray text-center mr-sm-3 order-2 order-sm-1 mt-4 mt-sm-0",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.closePopup.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font__family--gotham font__weight--medium font__color--white",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(
                                          _vm.$t("cancel", "user_account")
                                        ) +
                                        "\n                                    "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "button button__size-2 button__font--size-1 button__bg--dark text-center ml-sm-3 order-1 order-sm-2 mb-2 mb-sm-0",
                                class: {
                                  "button__bg--blue btn-loader": _vm.btn_loader,
                                },
                                on: { click: _vm.saveShippingData },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "font__family--gotham font__weight--medium font__color--white",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("save", "user_account"))
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }